import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * This function assumes the caller wants to remove the orchid pro from the caller's
 * practice group
 */
export default async function removeUserFromPracticeGroup(
  targetOrchidProUserId: string,
) {
  const res = await fetchOrchidAPI(
    `/api/users/v1/practice_group/orchid_pro/${targetOrchidProUserId}/remove_from_practice`,
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    const responseText = await res.text();
    console.error(getErrorDetail(responseText));
  }
  return res;
}
